import React from 'react';
import { useData } from '../../context/DataContext';
import { useSelector } from 'react-redux';
export const Sidebar = () => {
  const { activeTab, setActiveTab } = useData();
      const items = useSelector((state) => state.userDetailsData.LoginDetails);

  const menuItems = [
    { id: 'participation', label: 'Student Participation', icon: '✅' },
    { id: 'overview', label: 'Performance Overview', icon: '📊' },
    { id: 'curriculum', label: 'Curriculum Analysis', icon: '📖' },
    { id: 'reports', label: 'Report Card', icon: '📋' },
    // { id: 'papers', label: 'Question Papers', icon: '📝' },
  ];
// console.log("activeTab",activeTab);
  return (
    <aside
      className="app-sidebar hidden lg:block shadow-xl select-none w-100"
      style={{backgroundColor:"#347363",top:items?.userTypeId === 2 ? "10.8rem": "5rem"}}
    >
      <nav className="py-2 px-3 dflex">
        {menuItems.map((item) => {
          const isActive = activeTab === item.id;
          return (
            <button
              key={item.id} 
              onClick={() => setActiveTab(item.id)}
              className={`nav-item flex items-center space-x-4 p-2 rounded-xl text-white w-full text-left cursor-pointer ${
                isActive ? 'active' : ''
              }`}
            >
              <span className="text-2xl">{item.icon}</span>
              <span className="font-medium text-base">{item.label}</span>
            </button>
          );
        })}
      </nav>
    </aside>
  );
};
export default Sidebar;
